<div class="flex flex-col gap-4">
    <processes-filter class="px-2 py-[7px] border-b"></processes-filter>
    <lib-process-tree
        #processTree
        [editMode]="editMode()"
        [transformFunction]="transformFunction()"
        [translocoContent]="translocoButtonContent()"
        [processData]="processData()"
        [testScenarioData]="testScenarioData()"
        [mdoAreas]="mdoAreas()"
        [selectedProcess]="selectedProcess()"
        (treeNodeSelectionChange)="treeNodeSelectionChanged($event)"
        (menuItemClick)="menuItemClicked($event)"
        (dropListDrop)="dropListDrop($event)"
        (corruptTreeDataFixed)="corruptTreeDataFixed($event)"
        [canChangeTreeNodeSelection]="canChangeTreeNodeSelection.bind(this)"></lib-process-tree>
</div>
